




























































































































import Vue from "vue";
import store, { PaymentModeStore } from "../services/PaymentModeStore";
import Page from "../../../components/Page.vue";
import PaymentMode from "../models/PaymentMode";
import setAttribute from "../../../utils/dom";
import { t } from "@/plugins/i18n";

interface Data {
  store: PaymentModeStore;
}

const confirmationTemplate = {
  mounted() {
    setAttribute(".k-detail-cell", "colspan", "9");
  },
};

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    Page,
    confirmation: confirmationTemplate,
  },

  data(): Data {
    return {
      store,
    };
  },

  async beforeMount() {
    await this.store.loadPaymentModes();
  },

  computed: {
    columns: () => [
      { field: "name", title: t("Megnevezes") },
      {
        field: "promptPay",
        title: t("PaymentMode_AzonnaliPuITelj_2"),
        cell: "promptPayTemplate",
      },
      {
        field: "noCurrentAccount",
        title: t("PaymentMode_FolyszNemAtfuto"),
        cell: "noCurrentAccountTemplate",
      },
      {
        field: "creditCheck",
        title: t("PaymentMode_HitelkFigyeles"),
        cell: "creditCheckTemplate",
      },
      { field: "sapCode", title: t("PaymentMode_SAPKod") },
      { field: "webPayMode", title: t("PaymentMode_WebesFizMod") },
      { field: "isConstr", title: "Szerz.szerinti", cell: "isConstrTemplate" },
      { field: "partnerAccountCode", title: t("PaymentMode_PartnerFokSzam") },
      { cell: "commandTemplate", width: "120px" },
      { width: 0 },
    ],

    items() {
      return this.store.paymentModes;
    },
  },

  methods: {
    createPaymentMode() {
      this.$router.push(`/payment-mode/create`);
    },

    updatePaymentMode(item: PaymentMode) {
      this.$router.push(`/payment-mode/${item.id}/edit`);
    },

    deleteItem(item: PaymentMode) {
      this.store.setDeleting(item);
    },

    confirmDelete(item: PaymentMode) {
      item.deleting = false;
      this.store.deletePaymentMode(item.id);
    },

    cancelDelete(item: PaymentMode) {
      item.deleting = false;
    },
  },
});
